import { render, staticRenderFns } from "./ScanQRBody.vue?vue&type=template&id=6ca79a31&"
import script from "./ScanQRBody.vue?vue&type=script&lang=ts&"
export * from "./ScanQRBody.vue?vue&type=script&lang=ts&"
import style0 from "./ScanQRBody.vue?vue&type=style&index=0&id=6ca79a31&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports